const SITE_TYPE_SINGLE_ZONE = "SingleZone";
const SITE_TYPE_MULTIPLE_ZONE = "MultiZone";
const SITE_TYPE_EMBEDDED_NETWORK = 'Embedded Network';
const SITE_TYPE_EMBEDDED_NETWORK_END_USER = 'Embedded Network End User';

const SITE_KWKVA_UNITS_KW = 0;
const SITE_KWKVA_UNITS_KVA = 1;

const SITE_CSIP_ENERGEX = "EnergEX"


const SITE_TYPES = {
  SINGLE_ZONE: SITE_TYPE_SINGLE_ZONE,
  MULTIPLE_ZONE: SITE_TYPE_MULTIPLE_ZONE,
  EMBEDDED_NETWORK: SITE_TYPE_EMBEDDED_NETWORK,
  EMBEDDED_NETWORK_END_USER: SITE_TYPE_EMBEDDED_NETWORK_END_USER
};

const SITE_TYPE_LABELS = {
  [SITE_TYPE_SINGLE_ZONE]: "Single Zone",
  [SITE_TYPE_MULTIPLE_ZONE]: "Multi-Zone",
  [SITE_TYPE_EMBEDDED_NETWORK]:"Embedded Network",
  [SITE_TYPE_EMBEDDED_NETWORK_END_USER]:"Embedded Network (End user)"
};

const SITE_KWKVA_UNIT_LABELS = {
  [SITE_KWKVA_UNITS_KW]: "kW",
  [SITE_KWKVA_UNITS_KVA]:"kVA"
};

const SITE_KWKVA_UNITS = {
  KW: SITE_KWKVA_UNITS_KW,
  KVA: SITE_KWKVA_UNITS_KVA
};

const SITE_CSIP_LABELS = {
  [SITE_CSIP_ENERGEX]: "EnergEX"
};

const SITE_CSIP_SERVER = {
  ENERGEX: SITE_CSIP_ENERGEX
};

export default { SITE_TYPES, SITE_TYPE_LABELS };
export { SITE_TYPES, SITE_TYPE_LABELS };
export {SITE_KWKVA_UNIT_LABELS, SITE_KWKVA_UNITS};
export {SITE_CSIP_LABELS, SITE_CSIP_SERVER};
export {SITE_TYPE_MULTIPLE_ZONE,SITE_TYPE_EMBEDDED_NETWORK};
